var Phase;
(function (Phase) {
    Phase["local"] = "local";
    Phase["dev"] = "dev";
    Phase["test"] = "test";
    Phase["stage"] = "stage";
    Phase["real"] = "real";
})(Phase || (Phase = {}));
export default Phase;
